import clsx from 'clsx'
import isString from 'lodash/isString'
import React, { CSSProperties, FC, PropsWithChildren, ReactNode, Ref, useRef, useState } from 'react'

import SvgAngleLeft from '@Assets/SVG/AngleLeft'
import SvgAngleRight from '@Assets/SVG/AngleRight'
import { HTMLSliderElement, Slider } from '@Components/Slider'

import styles from './ProductCarousel.module.scss'

interface ProductSliderStyleProps extends CSSProperties {
  thumbColor?: string
}
export interface ProductSliderProps {
  className?: string
  'data-in-view'?: string
  header: ReactNode
  hideArrows?: boolean
  id?: string
  style?: ProductSliderStyleProps
  wrapperRef?: Ref<any>
}

export const ProductCarousel: FC<PropsWithChildren<ProductSliderProps>> = ({
  children,
  className,
  'data-in-view': dataInView,
  header,
  hideArrows,
  id,
  style,
  wrapperRef,
}) => {
  const exStyles: CSSProperties = {
    '--rangeThumbColor': style?.thumbColor || 'var(--black)',
    ...style,
  } as CSSProperties
  const sliderRef = useRef<HTMLSliderElement | null>(null)
  const [sliderState, setSliderState] = useState<{
    max: number
    min: number
    value: number
  } | null>(null)
  return (
    <div
      className={clsx(styles.productCarousel, className)}
      data-in-view={dataInView}
      id={id}
      ref={wrapperRef}
      style={{
        ...exStyles,
      }}
    >
      {!!header && (
        <div className={clsx(
          styles.top,
          'productCarouselHeader',
          Boolean(header) && styles.withHeader,
        )}
        >
          {isString(header) && <p className={styles.header}>{header}</p>}
          {!isString(header) && header}
        </div>
      )}
      {(!hideArrows && sliderState) && (
        <>
          <button className={clsx(styles.arrow, styles.left)} onClick={() => sliderRef.current?.prev()} type="button">
            {' '}
            <SvgAngleLeft />
          </button>
          <button className={clsx(styles.arrow, styles.right)} onClick={() => sliderRef.current?.next()} type="button">
            {' '}
            <SvgAngleRight />
          </button>
        </>
      )}
      <Slider
        className={styles.slider}
        onSlide={(e) => {
          if (!e.isScrollable) {
            setSliderState(null)
            return
          }
          setSliderState({
            max: e.rangeMax,
            min: e.rangeMin,
            value: e.rangeValue,
          })
        }}
        ref={sliderRef}
      >
        {children}
      </Slider>
      <input
        className={clsx(styles.range, !sliderState && styles.hidden)}
        max={sliderState?.max ?? 0}
        min={sliderState?.min ?? 0}
        onChange={() => null}
        type="range"
        value={sliderState?.value ?? 0}
      />
    </div>
  )
}
